import React, { useEffect, useState } from "react";
import { usersApi } from "../../../services/api";
import { User, UserClient, UserRoles } from "../types";
import { useNavigate } from "react-router";
import { TableRowType } from "../../../main/components/RopTable/RopTable";
import ListScreen from "../../../main/components/ListScreen";
import { Box, Tooltip, Typography } from "@mui/material";
import { formatDateAndHour } from "../../../main/utils/utils";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import BaseButton from "../../../main/components/BaseButton";
import * as XLSX from "xlsx";

export default function UsersList() {
  const [loading, setLoading] = useState(true);
  // const [search, setSearch] = useState("");
  const [users, setUsers] = useState<User[]>([]);
  const [pageIndex, setPageIndex] = useState(0);
  const page = pageIndex + 1;
  const navigate = useNavigate();

  useEffect(() => {
    mount();
  }, [
    pageIndex,
    ,
    // search
    25,
  ]);
  const mount = async () => {
    try {
      setLoading(true);
      const response = await usersApi
        .getUsers
        // page, search, undefined, 25
        ();
      if (response.total < page * 25) {
        setPageIndex(0);
      }
      setUsers(response.data);
      //setUsersAmount(response.total);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  function exportToXlsx(users: User[]) {
    const data: Record<string, any>[] = users.map((user) => ({
      Nome: user.name,
      "Último Login": user.lastActivity ? formatDateAndHour(user.lastActivity) : "Não informado",
      Telefone: user.phone ?? "Não informado",
      Email: user.email,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Usuários");

    XLSX.writeFile(workbook, "usuarios.xlsx");
  }

  const tableRows: TableRowType[] = users.map((user) => {
    return {
      rowItems: [
        {
          item: user.name,
          isMobile: true,
        },
        {
          item: <>{user.lastActivity ? formatDateAndHour(user.lastActivity) : "Não informado"}</>,
          isMobile: true,
          align: "center",
        },
        {
          item: user.phone ?? "Não informado",
          align: "center",
        },
        {
          item: user.email,
          align: "center",
          isMobile: true,
        },
        {
          item: <RolesCell clients={user?.clients} />,
          align: "center",
        },
        // {
        //   item: (
        //     <Tooltip title={userHasWhatsApp(user) ? "WhatsApp Ativado" : "WhatsApp Desativado"}>
        //       <WhatsAppIcon sx={{ color: userHasWhatsApp(user) ? "green" : "gray" }} />
        //     </Tooltip>
        //   ),
        //   align: "center",
        //   isMobile: false,
        // },
      ],
      onClick: () => {
        navigate(user.id);
      },
    };
  });

  return (
    <ListScreen
      headerRightComponent={<BaseButton
        onClick={(e) => { e.stopPropagation(); exportToXlsx(users) }}
        title="Exportar dados de usuários"
        startIcon={<FileDownloadIcon />}
      />}
      title="Usuários"
      onClick={() => {
        navigate("cadastrar");
      }}
      // search={search}
      // setSearch={setSearch}
      hover
      isLoading={loading}
      itemsHeaders={[
        {
          item: "Nome",
          isMobile: true,
        },
        {
          item: "Último Login",
          isMobile: true,
          align: "center",
        },
        {
          item: "Telefone",
          align: "center",
        },
        {
          item: "Email",
          align: "center",
          isMobile: true,
        },
        {
          item: "Clientes",
          isMobile: false,
          align: "center",
        },
      ]}
      itemRows={tableRows}
    />
  );
}

function RolesCell(props: { clients: UserClient[] }) {
  return (
    <>
      {props.clients?.map((client) => {
        const roles = client.roles
          .filter((role) => role != UserRoles.User)
          .join(", ");
        const rolesLabel =
          roles.length > 30 ? roles.slice(0, 40) + "..." : roles;
        return (
          <React.Fragment key={client.id}>
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
              <Box sx={{ marginRight: "12px" }}>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    paddingLeft: "10px",
                    paddingTop: "10px",
                    fontSize: "0.8em",
                  }}
                >
                  Cliente: {client.name}
                </Typography>
                <Typography
                  sx={{
                    paddingLeft: "10px",
                    paddingBottom: "10px",
                    color: "text.secondary",
                    fontSize: "0.8em",
                  }}
                >
                  Perfis: {rolesLabel}
                </Typography>
              </Box>
              <Box>
                <Tooltip title={client.whatsappNotificationConfiguration?.whatsappNotificationsEnabled ? "WhatsApp Ativado" : "WhatsApp Desativado"}>
                  <WhatsAppIcon sx={{ color: client.whatsappNotificationConfiguration?.whatsappNotificationsEnabled ? "green" : "gray" }} />
                </Tooltip>
              </Box>
            </Box>
          </React.Fragment>
        );
      })}
    </>
  );
}
